import React from 'react';

/**
 * Payment banner — dormant.
 *
 * The banner used to nag owners about failed subscription payments and
 * open a hosted billing portal. Billing is paused platform-wide while a
 * new processor is being brought online, so there's nothing to nag about;
 * the workspace's `subscription_status` is normalized to `paused_platform`
 * server-side. Component kept as a no-op so any existing imports keep
 * compiling — will be rewired once the new processor is live.
 */
export default function PaymentMethodBanner() {
  return null;
}
